var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-collapse-item',{attrs:{"name":_vm.name,"disabled":_vm.disabled}},[_c('template',{slot:"title"},[_vm._t("title",function(){return [_c('span',[_vm._v(_vm._s(_vm.title))])]})],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }